import React from 'react';

/**
 * FormField — label + optional help + control + inline error.
 */
const FormField = ({ id, label, help, error, required, optional, children }) => (
  <div className={`cy-field${error ? ' has-error' : ''}`}>
    <label className="cy-label" htmlFor={id}>
      {label}
      {required ? (
        <span className="cy-req" aria-hidden="true"> *</span>
      ) : null}
      {optional ? <span className="cy-opt"> (optional)</span> : null}
    </label>
    {help ? (
      <span className="cy-help" id={`${id}-help`}>
        {help}
      </span>
    ) : null}
    {children}
    {error ? (
      <span className="cy-error" id={`${id}-error`} role="alert">
        {error}
      </span>
    ) : null}
  </div>
);

export default FormField;
